import Button from 'src/components/common/button/button';

import IntroImage from '../../../../assets/images/quiz/intro-1.svg';
import styles from './intro-step.module.scss';

export const IntroStep = ({ onChange }: { onChange: () => void }) => (
  <div className={styles.container}>
    <div className={styles.imageContainer}>
      <IntroImage />,
    </div>
    <footer className={styles.footer}>
      <h1 className={styles.title}>
        Keep answering to improve your profile&apos;s fit
      </h1>
      <p className={styles.text}>
        Discover your true self with Eclipse by learning about the Moon&apos;s
        influence
      </p>
      <Button onClick={() => onChange()}>Improve my profile’s fit</Button>
    </footer>
  </div>
);
